<template>
  <custom-callout
    border-color="primary-2"
    class="mb-4 custom-callout rounded"
    :has-toggle="false"
  >
    <div class="py-2">
      <div class="d-flex">
        <icon-view
          class="mt-5 mb-3 mt-md-0 mt-sm-5"
          :gradient="false"
          icon="fas fa-file-invoice mb-1"
          icon-background="white"
          icon-color="#FF7058"
          icon-size="16px"
          :title="title"
        />
      </div>

      <div class="row my-3 ml-4">
        <custom-radio-button
          id="selected-region-rb"
          label="Región:"
          class="mb-2"
          v-model="regionSelection"
          name="selected-region-rb"
          :options="regionSelectionOptions"
          custom-error-msg="Favor seleccionar una opción."
          is-inline
          @input="onRegionSelectedHandler"
        />
      </div>

      <validation-observer ref="addAssistantObserver">
        <div class="row my-3 ml-4">
          <div class="col-md-3 col-sm-12 mr-md">
            <validation-provider v-slot="{ errors }" :rules="'required'">
              <custom-drop-down
                v-model="model.assistant"
                :custom-error-msg="'El asistente es requerido.'"
                :error="errors[0]"
                fieldkey="id"
                fieldname="name"
                label="Asistente:"
                :options="assistants"
                placeholder="Seleccione"       
              />
            </validation-provider>
          </div>

          <div class="col-md-3 col-sm-12  pt-2 ">
            <div class="mt-4">
              <action-button
                i="fas fa-times-circle"
                text="Cancelar"
                variant="outline-danger mr-3 pl-3 pr-4"
                @click="onClose"
              />
              <action-button
                i="fas fa-save"
                text="Guardar"
                variant="success pl-3 pr-3"
                @click="onSave"
              />
            </div>
          </div>
        </div>
      </validation-observer>
    </div>
  </custom-callout>
</template>
<script>
import CustomCallout from 'custom-callout';
import ActionButton from 'ActionButton';
import CustomDropDown from 'custom-drop-down';
import IconView from 'icon-view';
import CustomRadioButton from "custom-radio";
import { ValidationObserver, ValidationProvider } from 'vee-validate';

export default {
  name: 'AddAssistantCard',
  components: {
    IconView,
    ActionButton,    
    CustomDropDown,
    CustomCallout,
    ValidationObserver,
    ValidationProvider,
    CustomRadioButton,
  },
  props: {
    assistants: {
      type: Array,
      default: () => [],
    },   
    title: {
      type: String,
      required: true,
    },   
  },
  data: () => ({
    model: {
      assistant: null,      
    },
    regionSelection: false,
  }),
  computed: {
    regionSelectionOptions() {
      return [
        {
          label: 'En Mi Región',
          value: false,
        },
        {
          label: 'En Otra Región',
          value: true,
        },
      ];
    },
  },
  methods: {   
    onClose() {
      this.$emit('on-close');
    },
    onRegionSelectedHandler(val) {
      this.$emit('on-region-change', val);
    },
    async onSave() {
      const isValid = await this.$refs.addAssistantObserver.validate();
      if (!isValid) return;
      this.$emit('on-save', this.model);
    },
  },
};
</script>
